import { RISKS_CONFIGS as RISKS_CONFIGS_BASE } from '@gp/pages/StudioDashboard/StudioOverall/components/RiskTag/constants';

export const RISKS_CONFIGS: IStudioOverallRiskConfigs = {
  ...RISKS_CONFIGS_BASE,
  '2': {
    text: 'Medium',
    // #FF9D00
    color: 'rgb(255, 157, 0)',
    // #FF9D00 opacity 0.1
    backgroundColor: 'rgba(255, 157, 0, 0.1)',
  },
};
